import { render, staticRenderFns } from "./purchaseSummaryChart.vue?vue&type=template&id=639e37d0&"
import script from "./purchaseSummaryChart.vue?vue&type=script&lang=js&"
export * from "./purchaseSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports